import { GENERAL_DONATION } from "../../constants";
import { RESET_COUNTRY_DEPENDENT_VALUES, RESET_PAYMENT_METHOD, SET_ACH_REF, SET_GOOGLE_APPLE_ID, SET_GOOGLE_APPLE_REF, SET_STRIPE_REF, UPDATE_CHECKOUT_CONTACT_DETAILS, UPDATE_CHECKOUT_STATE, UPDATE_CURRENCY, UPDATE_DONATION_MESSAGE, UPDATE_DONATION_PROCESSING_STATE, UPDATE_STATE_BASED_ON_LOCATION, UPDATE_STATE_BASED_ON_PAGE_DETAILS } from "../actionTypes/CheckoutTypes";
import { handleCheckoutCurrencyChange, handleCheckoutStateChange, handleResetCountryDependentValues } from "../services/CheckoutServices";

export const checkoutUserState = {
    firstName: "",
    lastName: "",
    contactNumber: "",
    address: "",
    city: "",
    email: "",
    zipCode: "",
    country: "",
    countryState: "",
}

export const giftAidBillingState = {
    address: "",
    city: "",
    zipCode: "",
    country: "",
    countryState: "",
}

export const achIntentDetailsState = {
    donation_id: null,
    start_date: null,
    end_date: null,
    invoice_id: 0,
    stripe_sub_id: 0,
}

const checkoutState = {
    chequeNumber: null,
    donationAmount: null,
    stripePublicKey: null,
    paypalPublicKey: null,
    organizationName: null,
    selectedPaymentMethod: null,
    corporateMatchEmployer: null,
    volunteerId: null,

    currencyConversionRate: 0,
    transactionFeePercentage: 0,
    donationType: GENERAL_DONATION,
    isReferredByVolunteer: false,
    isRecurring: false,
    contactBySms: false,
    contactByEmail: false,
    contactByPhone: false,
    doubleTheImpact: false,
    donateAnonymously: false,
    doNotContactByPost: false,
    makeGiftAidDonation: false,
    isFundraiserCheckout: false,
    sameBillingForGiftAid: false,
    coverTheTransactionFee: false,
    leaveAMessageWithDonation: false,
    contactMeForCorporateMatch: false,
    achMode: null,
    achPaymentReady: false,
    achIntentDetails: { ...achIntentDetailsState },

    hblConfig: {},
    selectedBank: {
        bank_id: 0,
        bank_details: null
    },
    bankSlip: {
        attachment: null
    },
    selectedCountry: {
        id: 1,
        name: "Pakistan",
        code: "PK",
        currency: {
            id: 1,
            name: "PKR",
            symbol: "RS"
        }
    },

    userContactDetails: {
        ...checkoutUserState
    },

    giftAidBilling: {
        ...giftAidBillingState
    },

    selectedTeamMember: { id: 0, name: "" }
}

const donationProcessingState = false;

const checkoutPaymentRefsState = {
    stripeReference: null,
    ACHReference: null,
    googleApplePayReference: null,

}

export function donationCheckout(state = checkoutState, action) {
    switch (action.type) {
        case UPDATE_CHECKOUT_STATE:
            return handleCheckoutStateChange(action.event, state)

        case UPDATE_CURRENCY:
            return handleCheckoutCurrencyChange(action.currency, state)

        case RESET_COUNTRY_DEPENDENT_VALUES:
            return handleResetCountryDependentValues(state)

        case UPDATE_STATE_BASED_ON_LOCATION:
            const userCurrentLocation = action.location
            return {
                ...state,
                selectedCountry: {
                    id: userCurrentLocation.country_id,
                    name: userCurrentLocation.country_name,
                    code: userCurrentLocation.country_code,
                    currency: {
                        id: userCurrentLocation.currency_id,
                        code: userCurrentLocation.currency_code,
                        symbol: userCurrentLocation.symbol_left
                    }
                },
                donationMessage: userCurrentLocation.donation_message,
                currencyConversionRate: userCurrentLocation.currency_coversion_rate,
            }

        case UPDATE_STATE_BASED_ON_PAGE_DETAILS:
            return {
                ...state,
                donationMessage: action.pageDetails.donation_message,
                selectedCountry: {
                    id: action.pageDetails.country_id,
                    name: action.pageDetails.country_name,
                    code: action.pageDetails.country_code,
                    currency: {
                        id: action.pageDetails.currency_id,
                        code: action.pageDetails.code,
                        symbol: action.pageDetails.symbol_left
                    }
                },
                currencyConversionRate: action.pageDetails.value
            }

        case RESET_PAYMENT_METHOD:
            return {
                ...state,
                selectedPaymentMethod: "",
                transactionFeePercentage: 0,
                coverTheTransactionFee: false,
                achMode: null,
                achPaymentReady: false,
                achIntentDetails: { ...achIntentDetailsState },
            }

        case UPDATE_DONATION_MESSAGE:
            return {
                ...state,
                donationMessage: action.message,
            }

        case UPDATE_CHECKOUT_CONTACT_DETAILS:
            return {
                ...state,
                userContactDetails: {
                    ...state.userContactDetails,
                    ...action.contactDetails
                }
            }

        default:
            return state;
    }
}

export function checkoutProcessing(state = donationProcessingState, action) {
    switch (action.type) {
        case UPDATE_DONATION_PROCESSING_STATE:
            return action.processing
    
        default:
            return state
    }
}
export function googleApplePaymentId(state = null, action) {
    switch (action.type) {
        case SET_GOOGLE_APPLE_ID:
            return action.id
    
        default:
            return state
    }
}

export function checkoutPaymentRefs(state = checkoutPaymentRefsState, action) {
    switch (action.type) {
        case SET_ACH_REF:
            return {
                ...state,
                ACHReference: action.ref
            }
        case SET_STRIPE_REF:
            return {
                ...state,
                stripeReference: action.ref
            }
        case SET_GOOGLE_APPLE_REF:
            return {
                ...state,
                googleApplePayReference: action.ref
            }
    
        default:
            return state
    }
}